import { TagMatchMode } from '../../../../../_generated/graphql'
import { Item } from '../../../../components/multiple-select/multiple-select.component'
import {
  AssessmentTagMaster,
  SkillMap,
} from '../../../../services/assessment/assessment.mapping'
import { RoleModelSelectionSetting } from '../../../../services/user/user.service'

export interface RoleModelSelectionListRow {
  skillMapId: string
  skillMapName: string
  tagNames: string[]
  matchMode: TagMatchMode
  hasInvalidTags: boolean
  /** 編集できるか（スキルマップが存在し、有効なタグが 1 件以上ある） */
  canEdit: boolean
}

export function isActiveTag(
  tagMasters: AssessmentTagMaster[],
  id: string,
): boolean {
  return tagMasters.some((tag) => tag.id === id)
}

/** 設定済みだけをスキルマップ順に並べ、削除済みの設定は末尾に残す。 */
export function buildRoleModelSelectionRows(
  skillMaps: SkillMap[],
  tagMasters: AssessmentTagMaster[],
  settings: RoleModelSelectionSetting[],
): RoleModelSelectionListRow[] {
  const orderedSettings = [
    ...skillMaps.flatMap((skillMap) =>
      settings.filter((setting) => setting.skillMapId === skillMap.id),
    ),
    ...settings.filter(
      (setting) =>
        !skillMaps.some((skillMap) => skillMap.id === setting.skillMapId),
    ),
  ]
  return orderedSettings.map((setting) => {
    const skillMap = skillMaps.find((map) => map.id === setting.skillMapId)
    return {
      skillMapId: setting.skillMapId,
      skillMapName: skillMap == null ? '削除されたスキルマップ' : skillMap.name,
      tagNames: setting.tagMasterIds.map((id) => {
        const tag = tagMasters.find((tag) => tag.id === id)
        return tag == null ? '無効化されたタグ' : tag.name
      }),
      matchMode: setting.tagMatch,
      hasInvalidTags: setting.tagMasterIds.some(
        (id) => !isActiveTag(tagMasters, id),
      ),
      canEdit: skillMap != null && tagMasters.length > 0,
    }
  })
}

export function buildRoleModelTagItems(
  tagMasters: AssessmentTagMaster[],
  selectedTagMasterIds: string[],
): Item[] {
  return tagMasters.map((tag) => ({
    id: tag.id,
    label: tag.name,
    checked: selectedTagMasterIds.includes(tag.id),
  }))
}
